import { faComment, faCode } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getPromoCodeStore from "../../../../stores/auditor-store/promocode-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { AUDITOR_PROMOCODE_UPDATE } from "../../../../constants/picker-entries-constants";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const PromoCodeUpdate = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const promoCodeToUpdate = getPromoCodeStore().promoCodeToUpdate.get();
  const promoCodeIDToUpdate = getPromoCodeStore().promoCodeIDToUpdate.get();
  const disabled =
    !isDefinedString(promoCodeToUpdate) ||
    !isPositiveNumber(promoCodeIDToUpdate);

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"text"}
          icon={faComment}
          label={i18n.get("PROMO_CODE")}
          placeHolder={i18n.get("PROMO_CODE")}
          value={getPromoCodeStore().promoCodeToUpdate.get()}
          onChoose={(value: string) =>
            getPromoCodeStore().promoCodeToUpdate.set(value)
          }
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faCode}
          label={i18n.get("PROMO_CODE_ID")}
          placeHolder={i18n.get("PROMO_CODE_ID")}
          value={getPromoCodeStore().promoCodeIDToUpdate.get()}
          onChoose={(value: number) =>
            getPromoCodeStore().promoCodeIDToUpdate.set(value)
          }
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("PROMO_CODE_ACTIVE")}
          options={AUDITOR_PROMOCODE_UPDATE}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeStore().setPromoCodeIsActiveToUpdate(value);
          }}
          value={getPromoCodeStore().promoCodeIsActiveToUpdate.get()}
          style={{ marginRight: 10 }}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={!disabled}
        onClick={async () => {
          getPromoCodeStore().updatePromoCode();
        }}
        size="LARGE"
        text="EDIT"
        type="WARN"
      />
    </React.Fragment>
  );
});
export default PromoCodeUpdate;
